var map = {
	"./bg.png": "c344",
	"./footer.png": "3c98",
	"./game/1-1.png": "8e9a",
	"./game/1-2.png": "df6b",
	"./game/1-3.png": "c529",
	"./game/1-4.png": "9e95",
	"./game/2-1.png": "5050",
	"./game/2-2.png": "0bbd",
	"./game/2-3.png": "0eb7",
	"./game/2-4.png": "6105",
	"./game/3-1.png": "ca43",
	"./game/3-2.png": "11736",
	"./game/3-3.png": "27be",
	"./game/3-4.png": "bb41",
	"./game/4-1.png": "238e",
	"./game/4-2.png": "81bb",
	"./game/4-3.png": "519d",
	"./game/4-4.png": "46cf",
	"./game/5-1.png": "9b46",
	"./game/5-2.png": "190b",
	"./game/5-3.png": "a873",
	"./game/5-4.png": "70c9",
	"./hardware/1-1.png": "6421",
	"./hardware/1-2.png": "452e",
	"./hardware/1-3.png": "3e48",
	"./hardware/1-4.png": "9032",
	"./hardware/2-1.png": "7e42",
	"./hardware/2-2.png": "8810",
	"./hardware/2-3.png": "e20c",
	"./hardware/2-4.png": "a1ef",
	"./hardware/3-1.png": "4bb7",
	"./hardware/3-2.png": "5785",
	"./hardware/3-3.png": "4ba5",
	"./hardware/3-4.png": "51a6",
	"./hardware/4-1.png": "426a",
	"./hardware/4-2.png": "542c",
	"./hardware/4-3.png": "866d",
	"./hardware/4-4.png": "0109",
	"./hardware/5-1.png": "3c77",
	"./hardware/5-2.png": "61ec",
	"./hardware/5-3.png": "9aec",
	"./hardware/5-4.png": "885a",
	"./hardware/6-1.png": "fd35",
	"./hardware/6-2.png": "51f7",
	"./hardware/6-3.png": "4a63",
	"./hardware/6-4.png": "1a55",
	"./industry/1-1.png": "dd8e",
	"./industry/1-2.png": "55b0",
	"./industry/1-3.png": "2334",
	"./industry/1-4.png": "d3f6",
	"./industry/2-1.png": "3ac5",
	"./industry/2-2.png": "a926",
	"./industry/2-3.png": "5b16",
	"./industry/2-4.png": "b706",
	"./industry/3-1.png": "c563",
	"./industry/3-2.png": "a629",
	"./industry/3-3.png": "5dad",
	"./industry/3-4.png": "dd23",
	"./industry/4-1.png": "12ab",
	"./industry/4-2.png": "3e1f",
	"./industry/4-3.png": "d754",
	"./industry/4-4.png": "d28f",
	"./industry/5-1.png": "cd10",
	"./industry/5-2.png": "f789",
	"./industry/5-3.png": "cdeb",
	"./industry/5-4.png": "b2fb",
	"./line_bg0.png": "475c",
	"./line_bg1.png": "4820",
	"./t1.png": "266f",
	"./t1_ok.png": "e6b8",
	"./t2.png": "92eb",
	"./t2_ok.png": "6c2a",
	"./t3.png": "b63c",
	"./t3_ok.png": "ba71",
	"./tab_bg.png": "d452"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b02d";